// AI-ASSISTED: generated with claude-code on 2026-06-04, reviewed by Yoann Hertienne
import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';

const CreateRedirectPage = PageBlueprint.make({
  name: 'create-redirect',
  params: {
    path: '/create',
    loader: async () => {
      const { CreateRedirect } = await import('./CreateRedirect');
      return <CreateRedirect />;
    },
  },
});

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [SidebarContent, CreateRedirectPage],
});
